import { applyMiddleware, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import createRootReducer from "../reducers";
import rootSaga from "../sagas/index";
import persistState from "redux-localstorage";
  
const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
  const store = createStore(
    createRootReducer, // root reducer with router state
    compose(
      applyMiddleware(sagaMiddleware),
      persistState("auth")
    )
  );

  sagaMiddleware.run(rootSaga);
  return store;
}
